import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ProductBrand } from '@models/product-brand';

@Injectable({
  providedIn: 'root',
})
export class ProductBrandService {
  constructor(private http: HttpClient) {}

  addProductBrand(productBrand: ProductBrand) {
    return this.http.post<ProductBrand>(environment.baseUrl + 'api/ProductBrands', productBrand);
  }

  updateProduct(productBrand: ProductBrand) {
    return this.http.put<void>(environment.baseUrl + 'api/ProductBrands/' + productBrand.id, productBrand);
  }

  deleteProduct(productBrand: ProductBrand) {
    return this.http.delete(environment.baseUrl + 'api/ProductBrands/' + productBrand.id);
  }
}
